import $ from 'jquery';

export default function getEditorMargin(node: HTMLElement): number {
  // If the node is missing from DOM, silently assume margin of 0. Empirically, this has only happened as a
  // downstream effect of another error.
  if (!(node != null && $.contains(document.documentElement, node))) {
    return 0;
  }

  // Getting marginLeft from computed styles if margin is auto is unreliable. Instead, we take the parent's
  // inner width and subtract the node's width to get the total horizontal margin.
  return ($(node).parent().innerWidth() - $(node).outerWidth()) / 2;
}
